angular.module('swapick')
.controller('ServicesHistoryCtrl', ServicesHistoryCtrl);


function ServicesHistoryCtrl($scope, DataService, $ionicScrollDelegate, $ionicPopup,
  initialLoaderManager, $q, $ionicHistory, $state, $stateParams, Entities, notifyManager) {


  this.objects = [];
  this.meta = {};


  this.loadMore = () => {
    this.loading = true;
    //call again dataservice and push to the list
    return DataService.boughtServices.getList({
      limit:50, offset: this.objects.length, type:this.type})
    .then(items => {
      this.objects = this.objects.concat(items);
      this.meta = items.metadata;
      if(items.length){
        $ionicScrollDelegate.resize();
      }
      this.firstLoad = true;
      return items;
    })
    .finally(()=>{
      this.loading = false;
    })
    $scope.$broadcast('scroll.infiniteScrollComplete');
  }

  this.loader = initialLoaderManager.makeLoader(() => { return this.loadMore()}, true)


  this.hasMoreToLoad = () =>{
    return this.meta.next;
  }

}



// WEBPACK FOOTER //
// ./src/controllers/services-history-controller.js